import React, { Component } from 'react';
import './index.scss';
import { Route, Switch } from 'react-router';
import WordPairContainer from '../WordPairContainer';
import TokenContainer from '../SetBearerTokenContainer';
import LogoutContainer from '../LogoutContainer';

class App extends Component {
  render() {
    return (
        <Switch>
            <Route exact path="/" component={WordPairContainer}/>
            <Route exact path="/token" component={TokenContainer}/>
            <Route exact path="/logout" component={LogoutContainer}/>
            <Route component={() => <h1>404 Not Found</h1>}/>
        </Switch>
    );
  }
}

export default App;
